import styled from "styled-components";
export const rowHeight = 35;
export const Container = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;
export const FilterContainer = styled.div `
  padding: 24px;

  border-bottom: 2px solid #eee;
`;
export const TableContainer = styled.div `
  width: 100%;

  flex: 1;

  overflow: hidden;
`;
export const TableRowHeader = styled.div `
  background: var(--ant-primary-color);
  color: white;
  font-size: 14px;

  height: ${rowHeight}px;
`;
export const TableRowLabels = styled.div `
  display: flex;
  flex-direction: row;

  border-bottom: 1px solid #eee;

  font-weight: bold;

  height: ${rowHeight}px;
`;
export const TableRowData = styled.div `
  display: flex;
  flex-direction: row;

  border-bottom: 1px solid #eee;

  height: ${rowHeight}px;

  &.even {
    background: #fafafa;
    border-bottom: 1px solid #eee;
  }
`;
export const TableCellFull = styled.div `
  width: 100%;
  padding: 0 5px;
  line-height: ${rowHeight - 1}px;
`;
export const TableCell = styled.div `
  padding: 0 5px;

  width: 100%;

  overflow: hidden;
`;
export const TableCellName = styled(TableCell) `
  flex: 1;

  line-height: ${rowHeight - 1}px;
`;
export const TableCellValue = styled(TableCell) `
  width: 250px;

  &.mobile {
    width: 50%;
  }

  line-height: ${rowHeight - 1}px;
`;
export const TableCellDate = styled(TableCell) `
  width: 120px;

  line-height: ${rowHeight - 1}px;

  &.mobile {
    display: none;
  }
`;
export const TableCellAction = styled(TableCell) `
  width: 40px;

  line-height: 0px;
  padding: ${(rowHeight - 1 - 24 - 2) / 2}px 5px;
`;
//# sourceMappingURL=data:application/json;base64,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